import { useId, useState } from 'react';
import { Button } from '@yaradigitallabs/ahua-react';
import AceEditor from 'react-ace';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-text';
import 'ace-builds/src-noconflict/theme-monokai';
import { copyToClipboard } from '../../utils/clipboard';

export default function CodeBlock({
  code,
  language,
}: {
  code: string;
  language: string;
}) {
  const id = useId();
  const [copyStatus, setCopyStatus] = useState('');
  const isPython = ['python', 'py', 'python3'].includes(language.toLowerCase());

  const copy = async () => {
    setCopyStatus(
      (await copyToClipboard(code))
        ? 'Copied'
        : 'Could not copy. Select the code and copy it manually.'
    );
  };

  return (
    <div className="fm-code">
      <div className="fm-code-toolbar">
        <span>{language || 'Code'}</span>
        <Button
          variant="ghost"
          size="xs"
          colorConcept="inverse"
          type="button"
          onClick={copy}
          aria-label="Copy code"
        >
          <ClipboardDocumentIcon aria-hidden="true" />
          Copy
        </Button>
      </div>
      <AceEditor
        name={`formula-mate-code-${id}`}
        mode={isPython ? 'python' : 'text'}
        theme="monokai"
        value={code}
        width="100%"
        fontSize={12}
        readOnly
        wrapEnabled
        minLines={2}
        maxLines={18}
        showGutter={false}
        showPrintMargin={false}
        highlightActiveLine={false}
        setOptions={{ useWorker: false, highlightSelectedWord: false }}
        onLoad={editor => {
          editor.textInput
            .getElement()
            .setAttribute('aria-label', 'Returned code');
        }}
      />
      <span className="fm-copy-status" role="status">
        {copyStatus}
      </span>
    </div>
  );
}
